import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'composeExperienceUrls',
  isDragable: true,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  removeMessage:'Are you sure you want to remove the media URL from this live?',
  emptyMessage: "You don't have composed experiences linked with this live event, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'url',
      label: 'URL',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'URL of the link.',
    },
    {
      attributeName: 'video_type',
      label: 'Video Type',
      default: 'Autodetect',
      type: FormInputTypes.SELECT,
      helpText: 'Choose one type of content.',
      options: [
        { name: '(Unknown)', value: '-1' },
        { name: '(Autodetect)', value: 'Autodetect' },
        { name: 'Single view', value: 'Single-View' },
        { name: 'Multi view', value: 'Multi-View' },
        { name: 'Immersive', value: 'Immersive' },
        { name: 'Immersive + Multi-View', value: 'Immersive-Multi-View' },
      ],
      canEdit: true,
      canCreate: true,
    },
  ],
};
